module.exports = __webpack_public_path__ + "static/img/sq.389a4855.png";